import React, { useState } from 'react'
import { Password } from 'primereact/password'
import ApiService from '../../../services/ApiService'
import OrdenoLogo from '../../../pages/Login/Login/img-login/ordeno-logo.png'

import {
  FullPageWrapper,
  Box,
  Logo,
  Title,
  Subtitle,
  PassLabel,
  PasswordChecks,
  PasswordCheckItem,
  SubmitButton,
  BackRow,
  BackIcon,
  BackText,
  ErrorText,
} from './style2'

interface ResetPasswordProps {
  setPage: (page: string) => void
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ setPage }) => {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const resetToken = localStorage.getItem('resetOTP') || ''

  const hasMinLen = newPassword.length >= 8
  const hasUpperLower = /[A-Z]/.test(newPassword) && /[a-z]/.test(newPassword)
  const hasSpecialOrNumber = /[\W\d]/.test(newPassword)
  const matches = newPassword.length > 0 && newPassword === confirmPassword

  const canSubmit =
    hasMinLen && hasUpperLower && hasSpecialOrNumber && matches && !!resetToken

  const handleSubmit = async () => {
    if (!canSubmit || loading) return
    setLoading(true)
    setError('')

    try {
      await ApiService.auth.resetPasswordConfirm({
        resetToken,
        newPassword,
      })

      // depois de redefinir, volta pro login
      setPage('ResetSuccess')
    } catch (err: any) {
      console.log(err)
      setError('Não foi possível redefinir a senha. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <FullPageWrapper>
      <Box>
        <Logo src={OrdenoLogo} alt='ordeno' />

        <Title>Crie uma nova senha</Title>
        <Subtitle>
          Sua senha precisa ser diferente das já utilizadas anteriormente.
        </Subtitle>

        <PassLabel>Nova senha</PassLabel>
        <Password
          value={newPassword}
          onChange={(e) => setNewPassword(String(e.target.value))}
          className='passInput'
          placeholder='Digite aqui'
          feedback={false}
          toggleMask
        />

        <PassLabel>Confirmar senha</PassLabel>
        <Password
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(String(e.target.value))}
          className='passInput'
          placeholder='Digite aqui'
          feedback={false}
          toggleMask
        />

        <PasswordChecks>
          <PasswordCheckItem $ok={hasMinLen}>
            Deve ter no mínimo 8 caracteres
          </PasswordCheckItem>
          <PasswordCheckItem $ok={hasUpperLower}>
            Deve conter maiúsculas e minúsculas
          </PasswordCheckItem>
          <PasswordCheckItem $ok={hasSpecialOrNumber}>
            Deve ter ao menos um caractere especial
          </PasswordCheckItem>
        </PasswordChecks>

        {error && <ErrorText>{error}</ErrorText>}

        <SubmitButton
          type='button'
          disabled={!canSubmit || loading}
          onClick={handleSubmit}
        >
          {loading ? 'Enviando…' : 'Redefinir senha'}
        </SubmitButton>

        <BackRow onClick={() => setPage('Main')}>
          <BackIcon>←</BackIcon>
          <BackText>Voltar ao login</BackText>
        </BackRow>
      </Box>
    </FullPageWrapper>
  )
}

export default ResetPassword
